import styled from 'styled-components';

export const Content = styled.div`
  padding: 16px 20px 20px;
  box-sizing: border-box;
  input {
    font-size: 14px;
    letter-spacing: 0.5px;
    color: #e6eaec;
    padding: 0 10px;
    height: 36px;
    box-sizing: border-box;
    border-radius: 9px;
    width: 100%;
    background: #10151a;
    border: 1px solid #3d4952;
    outline: none;
    transition:
      border-color 0.15s ease,
      box-shadow 0.15s ease;
    &:focus {
      border-color: #47b972;
      box-shadow: 0 0 0 3px rgba(71, 185, 114, 0.16);
    }
    /* hide number spinners for a clean CP look */
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    -moz-appearance: textfield;
  }
`;

export const Buttons = styled.div`
  justify-content: space-between;
  display: flex;
`;

export const Item = styled.div`
  margin: 0 0 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const Title = styled.div`
  width: 90px;
  color: #e6eaec;
  font-size: 14px;
  font-weight: 600;
  padding-right: 16px;
`;

export const Value = styled.div`
  width: 92px;
  margin-right: 16px;
  input {
    height: 40px;
  }
`;

export const ItemButtons = styled.div`
  margin-left: auto;
`;
